<app-notification *ngIf="errorCode" type="error">{{'app-login.login-failure-message.' + errorCode | translate }}</app-notification>
